import './OrderStatusBadge.scss';
import React from 'react';
import { OrderStatus } from '@services/product/order/order.types';
import { ORDER_STATUS } from '@utils/enumTranslation';

export type OrderStatusBadgeProps = {
    status: OrderStatus;
};

export const OrderStatusBadge: React.FC<OrderStatusBadgeProps> = ({ status }) => {
    return <div className={`order-status-badge ${status}`}>{ORDER_STATUS[status]}</div>;
};
